/**
 * UI-6b Task 5/7 — Widget registry storage.
 *
 * This file contains *only* the registry state + register/lookup helpers.
 * Widget manifests import from here (instead of from `./index.js`) so that
 * loading a manifest module never triggers the side-effect imports in
 * `./index.ts`, which would otherwise create a circular dependency:
 *   index.ts -> sla-gauge/manifest.ts -> index.ts (registerWidget undefined).
 *
 * Consumers (composer, renderer, library sidebar) should import from
 * `./index.js` so the side-effect imports there have a chance to register
 * each manifest at module-load time.
 */
import type { WidgetManifest } from './types.js'

/** Populated by side-effect imports in `./index.ts`. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- registry holds manifests for heterogeneous widget types; a common any-bounded map is the standard pattern here
export const WIDGET_REGISTRY: Record<string, WidgetManifest<any>> = {}

export function registerWidget<T>(manifest: WidgetManifest<T>): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- erasing the generic param when storing into the heterogeneous registry map; retrieval is type-safe via getWidget
  WIDGET_REGISTRY[manifest.type] = manifest as WidgetManifest<any>
}

export function getWidget(type: string): WidgetManifest | undefined {
  return WIDGET_REGISTRY[type]
}
